import store from '../store';

// This is a simple wrapper to making logging more convenient like console.log

// This is the main function we want wrapped
function callLogger(level, args) {
  store.dispatch('logAction', {level: level, args: args}).then(() => {});
}


let logger = {

  debug() {
    callLogger('debug', arguments);
  },

  info() {
    callLogger('info', arguments);
  },

  log () {
    callLogger('info', arguments);
  },

  warn() {
    callLogger('warn', arguments);
  },

  error() {
    callLogger('error', arguments);
  }
};

export default logger;



// WEBPACK FOOTER //
// ./src/lib/logger.js